/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated.index'
import { Route as AuthCallbackImport } from './routes/auth.callback'
import { Route as AuthenticatedSearchImport } from './routes/_authenticated.search'
import { Route as AuthenticatedOcppImport } from './routes/_authenticated.ocpp'
import { Route as AuthenticatedCompareImport } from './routes/_authenticated.compare'
import { Route as AuthenticatedApiExplorerImport } from './routes/_authenticated.api-explorer'
import { Route as AuthenticatedApiExplorerIndexImport } from './routes/_authenticated.api-explorer.index'
import { Route as AuthenticatedSearchQueryConsoleImport } from './routes/_authenticated.search.query-console'
import { Route as AuthenticatedSearchIndexesImport } from './routes/_authenticated.search.indexes'
import { Route as AuthenticatedSearchForceUpdateImport } from './routes/_authenticated.search.force-update'
import { Route as AuthenticatedOcppCpaChangeHistoryImport } from './routes/_authenticated.ocpp.cpa-change-history'
import { Route as AuthenticatedGoldenReviewImport } from './routes/_authenticated.golden.review'
import { Route as AuthenticatedGoldenJudgeImport } from './routes/_authenticated.golden.judge'
import { Route as AuthenticatedEvaluationRetrievalImport } from './routes/_authenticated.evaluation.retrieval'
import { Route as AuthenticatedDataSearchTermsImport } from './routes/_authenticated.data.search-terms'
import { Route as AuthenticatedDataQueriesImport } from './routes/_authenticated.data.queries'
import { Route as AuthenticatedBenchmarkTypoCorrectionImport } from './routes/_authenticated.benchmark.typo-correction'
import { Route as AuthenticatedBenchmarkSearch360OutputImport } from './routes/_authenticated.benchmark.search360-output'
import { Route as AuthenticatedBenchmarkMatchProductsImport } from './routes/_authenticated.benchmark.match-products'
import { Route as AuthenticatedBenchmarkConsumerProductsImport } from './routes/_authenticated.benchmark.consumer-products'
import { Route as AuthenticatedBenchmarkConceptsImport } from './routes/_authenticated.benchmark.concepts'
import { Route as AuthenticatedApiExplorerServiceImport } from './routes/_authenticated.api-explorer.$service'

// Create/Update Routes

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedSearchRoute = AuthenticatedSearchImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedOcppRoute = AuthenticatedOcppImport.update({
  id: '/ocpp',
  path: '/ocpp',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedCompareRoute = AuthenticatedCompareImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedApiExplorerRoute = AuthenticatedApiExplorerImport.update({
  id: '/api-explorer',
  path: '/api-explorer',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedApiExplorerIndexRoute =
  AuthenticatedApiExplorerIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedApiExplorerRoute,
  } as any)

const AuthenticatedSearchQueryConsoleRoute =
  AuthenticatedSearchQueryConsoleImport.update({
    id: '/query-console',
    path: '/query-console',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any)

const AuthenticatedSearchIndexesRoute = AuthenticatedSearchIndexesImport.update(
  {
    id: '/indexes',
    path: '/indexes',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any,
)

const AuthenticatedSearchForceUpdateRoute =
  AuthenticatedSearchForceUpdateImport.update({
    id: '/force-update',
    path: '/force-update',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any)

const AuthenticatedOcppCpaChangeHistoryRoute =
  AuthenticatedOcppCpaChangeHistoryImport.update({
    id: '/cpa-change-history',
    path: '/cpa-change-history',
    getParentRoute: () => AuthenticatedOcppRoute,
  } as any)

const AuthenticatedGoldenReviewRoute = AuthenticatedGoldenReviewImport.update({
  id: '/golden/review',
  path: '/golden/review',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedGoldenJudgeRoute = AuthenticatedGoldenJudgeImport.update({
  id: '/golden/judge',
  path: '/golden/judge',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedEvaluationRetrievalRoute =
  AuthenticatedEvaluationRetrievalImport.update({
    id: '/evaluation/retrieval',
    path: '/evaluation/retrieval',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedDataSearchTermsRoute =
  AuthenticatedDataSearchTermsImport.update({
    id: '/data/search-terms',
    path: '/data/search-terms',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedDataQueriesRoute = AuthenticatedDataQueriesImport.update({
  id: '/data/queries',
  path: '/data/queries',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedBenchmarkTypoCorrectionRoute =
  AuthenticatedBenchmarkTypoCorrectionImport.update({
    id: '/benchmark/typo-correction',
    path: '/benchmark/typo-correction',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedBenchmarkSearch360OutputRoute =
  AuthenticatedBenchmarkSearch360OutputImport.update({
    id: '/benchmark/search360-output',
    path: '/benchmark/search360-output',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedBenchmarkMatchProductsRoute =
  AuthenticatedBenchmarkMatchProductsImport.update({
    id: '/benchmark/match-products',
    path: '/benchmark/match-products',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedBenchmarkConsumerProductsRoute =
  AuthenticatedBenchmarkConsumerProductsImport.update({
    id: '/benchmark/consumer-products',
    path: '/benchmark/consumer-products',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedBenchmarkConceptsRoute =
  AuthenticatedBenchmarkConceptsImport.update({
    id: '/benchmark/concepts',
    path: '/benchmark/concepts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedApiExplorerServiceRoute =
  AuthenticatedApiExplorerServiceImport.update({
    id: '/$service',
    path: '/$service',
    getParentRoute: () => AuthenticatedApiExplorerRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/api-explorer': {
      id: '/_authenticated/api-explorer'
      path: '/api-explorer'
      fullPath: '/api-explorer'
      preLoaderRoute: typeof AuthenticatedApiExplorerImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/compare': {
      id: '/_authenticated/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof AuthenticatedCompareImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/ocpp': {
      id: '/_authenticated/ocpp'
      path: '/ocpp'
      fullPath: '/ocpp'
      preLoaderRoute: typeof AuthenticatedOcppImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/search': {
      id: '/_authenticated/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedSearchImport
      parentRoute: typeof AuthenticatedImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/api-explorer/$service': {
      id: '/_authenticated/api-explorer/$service'
      path: '/$service'
      fullPath: '/api-explorer/$service'
      preLoaderRoute: typeof AuthenticatedApiExplorerServiceImport
      parentRoute: typeof AuthenticatedApiExplorerImport
    }
    '/_authenticated/benchmark/concepts': {
      id: '/_authenticated/benchmark/concepts'
      path: '/benchmark/concepts'
      fullPath: '/benchmark/concepts'
      preLoaderRoute: typeof AuthenticatedBenchmarkConceptsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/benchmark/consumer-products': {
      id: '/_authenticated/benchmark/consumer-products'
      path: '/benchmark/consumer-products'
      fullPath: '/benchmark/consumer-products'
      preLoaderRoute: typeof AuthenticatedBenchmarkConsumerProductsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/benchmark/match-products': {
      id: '/_authenticated/benchmark/match-products'
      path: '/benchmark/match-products'
      fullPath: '/benchmark/match-products'
      preLoaderRoute: typeof AuthenticatedBenchmarkMatchProductsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/benchmark/search360-output': {
      id: '/_authenticated/benchmark/search360-output'
      path: '/benchmark/search360-output'
      fullPath: '/benchmark/search360-output'
      preLoaderRoute: typeof AuthenticatedBenchmarkSearch360OutputImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/benchmark/typo-correction': {
      id: '/_authenticated/benchmark/typo-correction'
      path: '/benchmark/typo-correction'
      fullPath: '/benchmark/typo-correction'
      preLoaderRoute: typeof AuthenticatedBenchmarkTypoCorrectionImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/data/queries': {
      id: '/_authenticated/data/queries'
      path: '/data/queries'
      fullPath: '/data/queries'
      preLoaderRoute: typeof AuthenticatedDataQueriesImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/data/search-terms': {
      id: '/_authenticated/data/search-terms'
      path: '/data/search-terms'
      fullPath: '/data/search-terms'
      preLoaderRoute: typeof AuthenticatedDataSearchTermsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/evaluation/retrieval': {
      id: '/_authenticated/evaluation/retrieval'
      path: '/evaluation/retrieval'
      fullPath: '/evaluation/retrieval'
      preLoaderRoute: typeof AuthenticatedEvaluationRetrievalImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/golden/judge': {
      id: '/_authenticated/golden/judge'
      path: '/golden/judge'
      fullPath: '/golden/judge'
      preLoaderRoute: typeof AuthenticatedGoldenJudgeImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/golden/review': {
      id: '/_authenticated/golden/review'
      path: '/golden/review'
      fullPath: '/golden/review'
      preLoaderRoute: typeof AuthenticatedGoldenReviewImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/ocpp/cpa-change-history': {
      id: '/_authenticated/ocpp/cpa-change-history'
      path: '/cpa-change-history'
      fullPath: '/ocpp/cpa-change-history'
      preLoaderRoute: typeof AuthenticatedOcppCpaChangeHistoryImport
      parentRoute: typeof AuthenticatedOcppImport
    }
    '/_authenticated/search/force-update': {
      id: '/_authenticated/search/force-update'
      path: '/force-update'
      fullPath: '/search/force-update'
      preLoaderRoute: typeof AuthenticatedSearchForceUpdateImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/search/indexes': {
      id: '/_authenticated/search/indexes'
      path: '/indexes'
      fullPath: '/search/indexes'
      preLoaderRoute: typeof AuthenticatedSearchIndexesImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/search/query-console': {
      id: '/_authenticated/search/query-console'
      path: '/query-console'
      fullPath: '/search/query-console'
      preLoaderRoute: typeof AuthenticatedSearchQueryConsoleImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/api-explorer/': {
      id: '/_authenticated/api-explorer/'
      path: '/'
      fullPath: '/api-explorer/'
      preLoaderRoute: typeof AuthenticatedApiExplorerIndexImport
      parentRoute: typeof AuthenticatedApiExplorerImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedApiExplorerRouteChildren {
  AuthenticatedApiExplorerServiceRoute: typeof AuthenticatedApiExplorerServiceRoute
  AuthenticatedApiExplorerIndexRoute: typeof AuthenticatedApiExplorerIndexRoute
}

const AuthenticatedApiExplorerRouteChildren: AuthenticatedApiExplorerRouteChildren =
  {
    AuthenticatedApiExplorerServiceRoute: AuthenticatedApiExplorerServiceRoute,
    AuthenticatedApiExplorerIndexRoute: AuthenticatedApiExplorerIndexRoute,
  }

const AuthenticatedApiExplorerRouteWithChildren =
  AuthenticatedApiExplorerRoute._addFileChildren(
    AuthenticatedApiExplorerRouteChildren,
  )

interface AuthenticatedOcppRouteChildren {
  AuthenticatedOcppCpaChangeHistoryRoute: typeof AuthenticatedOcppCpaChangeHistoryRoute
}

const AuthenticatedOcppRouteChildren: AuthenticatedOcppRouteChildren = {
  AuthenticatedOcppCpaChangeHistoryRoute:
    AuthenticatedOcppCpaChangeHistoryRoute,
}

const AuthenticatedOcppRouteWithChildren =
  AuthenticatedOcppRoute._addFileChildren(AuthenticatedOcppRouteChildren)

interface AuthenticatedSearchRouteChildren {
  AuthenticatedSearchForceUpdateRoute: typeof AuthenticatedSearchForceUpdateRoute
  AuthenticatedSearchIndexesRoute: typeof AuthenticatedSearchIndexesRoute
  AuthenticatedSearchQueryConsoleRoute: typeof AuthenticatedSearchQueryConsoleRoute
}

const AuthenticatedSearchRouteChildren: AuthenticatedSearchRouteChildren = {
  AuthenticatedSearchForceUpdateRoute: AuthenticatedSearchForceUpdateRoute,
  AuthenticatedSearchIndexesRoute: AuthenticatedSearchIndexesRoute,
  AuthenticatedSearchQueryConsoleRoute: AuthenticatedSearchQueryConsoleRoute,
}

const AuthenticatedSearchRouteWithChildren =
  AuthenticatedSearchRoute._addFileChildren(AuthenticatedSearchRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedApiExplorerRoute: typeof AuthenticatedApiExplorerRouteWithChildren
  AuthenticatedCompareRoute: typeof AuthenticatedCompareRoute
  AuthenticatedOcppRoute: typeof AuthenticatedOcppRouteWithChildren
  AuthenticatedSearchRoute: typeof AuthenticatedSearchRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedBenchmarkConceptsRoute: typeof AuthenticatedBenchmarkConceptsRoute
  AuthenticatedBenchmarkConsumerProductsRoute: typeof AuthenticatedBenchmarkConsumerProductsRoute
  AuthenticatedBenchmarkMatchProductsRoute: typeof AuthenticatedBenchmarkMatchProductsRoute
  AuthenticatedBenchmarkSearch360OutputRoute: typeof AuthenticatedBenchmarkSearch360OutputRoute
  AuthenticatedBenchmarkTypoCorrectionRoute: typeof AuthenticatedBenchmarkTypoCorrectionRoute
  AuthenticatedDataQueriesRoute: typeof AuthenticatedDataQueriesRoute
  AuthenticatedDataSearchTermsRoute: typeof AuthenticatedDataSearchTermsRoute
  AuthenticatedEvaluationRetrievalRoute: typeof AuthenticatedEvaluationRetrievalRoute
  AuthenticatedGoldenJudgeRoute: typeof AuthenticatedGoldenJudgeRoute
  AuthenticatedGoldenReviewRoute: typeof AuthenticatedGoldenReviewRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedApiExplorerRoute: AuthenticatedApiExplorerRouteWithChildren,
  AuthenticatedCompareRoute: AuthenticatedCompareRoute,
  AuthenticatedOcppRoute: AuthenticatedOcppRouteWithChildren,
  AuthenticatedSearchRoute: AuthenticatedSearchRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedBenchmarkConceptsRoute: AuthenticatedBenchmarkConceptsRoute,
  AuthenticatedBenchmarkConsumerProductsRoute:
    AuthenticatedBenchmarkConsumerProductsRoute,
  AuthenticatedBenchmarkMatchProductsRoute:
    AuthenticatedBenchmarkMatchProductsRoute,
  AuthenticatedBenchmarkSearch360OutputRoute:
    AuthenticatedBenchmarkSearch360OutputRoute,
  AuthenticatedBenchmarkTypoCorrectionRoute:
    AuthenticatedBenchmarkTypoCorrectionRoute,
  AuthenticatedDataQueriesRoute: AuthenticatedDataQueriesRoute,
  AuthenticatedDataSearchTermsRoute: AuthenticatedDataSearchTermsRoute,
  AuthenticatedEvaluationRetrievalRoute: AuthenticatedEvaluationRetrievalRoute,
  AuthenticatedGoldenJudgeRoute: AuthenticatedGoldenJudgeRoute,
  AuthenticatedGoldenReviewRoute: AuthenticatedGoldenReviewRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/api-explorer': typeof AuthenticatedApiExplorerRouteWithChildren
  '/compare': typeof AuthenticatedCompareRoute
  '/ocpp': typeof AuthenticatedOcppRouteWithChildren
  '/search': typeof AuthenticatedSearchRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AuthenticatedIndexRoute
  '/api-explorer/$service': typeof AuthenticatedApiExplorerServiceRoute
  '/benchmark/concepts': typeof AuthenticatedBenchmarkConceptsRoute
  '/benchmark/consumer-products': typeof AuthenticatedBenchmarkConsumerProductsRoute
  '/benchmark/match-products': typeof AuthenticatedBenchmarkMatchProductsRoute
  '/benchmark/search360-output': typeof AuthenticatedBenchmarkSearch360OutputRoute
  '/benchmark/typo-correction': typeof AuthenticatedBenchmarkTypoCorrectionRoute
  '/data/queries': typeof AuthenticatedDataQueriesRoute
  '/data/search-terms': typeof AuthenticatedDataSearchTermsRoute
  '/evaluation/retrieval': typeof AuthenticatedEvaluationRetrievalRoute
  '/golden/judge': typeof AuthenticatedGoldenJudgeRoute
  '/golden/review': typeof AuthenticatedGoldenReviewRoute
  '/ocpp/cpa-change-history': typeof AuthenticatedOcppCpaChangeHistoryRoute
  '/search/force-update': typeof AuthenticatedSearchForceUpdateRoute
  '/search/indexes': typeof AuthenticatedSearchIndexesRoute
  '/search/query-console': typeof AuthenticatedSearchQueryConsoleRoute
  '/api-explorer/': typeof AuthenticatedApiExplorerIndexRoute
}

export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/compare': typeof AuthenticatedCompareRoute
  '/ocpp': typeof AuthenticatedOcppRouteWithChildren
  '/search': typeof AuthenticatedSearchRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AuthenticatedIndexRoute
  '/api-explorer/$service': typeof AuthenticatedApiExplorerServiceRoute
  '/benchmark/concepts': typeof AuthenticatedBenchmarkConceptsRoute
  '/benchmark/consumer-products': typeof AuthenticatedBenchmarkConsumerProductsRoute
  '/benchmark/match-products': typeof AuthenticatedBenchmarkMatchProductsRoute
  '/benchmark/search360-output': typeof AuthenticatedBenchmarkSearch360OutputRoute
  '/benchmark/typo-correction': typeof AuthenticatedBenchmarkTypoCorrectionRoute
  '/data/queries': typeof AuthenticatedDataQueriesRoute
  '/data/search-terms': typeof AuthenticatedDataSearchTermsRoute
  '/evaluation/retrieval': typeof AuthenticatedEvaluationRetrievalRoute
  '/golden/judge': typeof AuthenticatedGoldenJudgeRoute
  '/golden/review': typeof AuthenticatedGoldenReviewRoute
  '/ocpp/cpa-change-history': typeof AuthenticatedOcppCpaChangeHistoryRoute
  '/search/force-update': typeof AuthenticatedSearchForceUpdateRoute
  '/search/indexes': typeof AuthenticatedSearchIndexesRoute
  '/search/query-console': typeof AuthenticatedSearchQueryConsoleRoute
  '/api-explorer': typeof AuthenticatedApiExplorerIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/_authenticated/api-explorer': typeof AuthenticatedApiExplorerRouteWithChildren
  '/_authenticated/compare': typeof AuthenticatedCompareRoute
  '/_authenticated/ocpp': typeof AuthenticatedOcppRouteWithChildren
  '/_authenticated/search': typeof AuthenticatedSearchRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/api-explorer/$service': typeof AuthenticatedApiExplorerServiceRoute
  '/_authenticated/benchmark/concepts': typeof AuthenticatedBenchmarkConceptsRoute
  '/_authenticated/benchmark/consumer-products': typeof AuthenticatedBenchmarkConsumerProductsRoute
  '/_authenticated/benchmark/match-products': typeof AuthenticatedBenchmarkMatchProductsRoute
  '/_authenticated/benchmark/search360-output': typeof AuthenticatedBenchmarkSearch360OutputRoute
  '/_authenticated/benchmark/typo-correction': typeof AuthenticatedBenchmarkTypoCorrectionRoute
  '/_authenticated/data/queries': typeof AuthenticatedDataQueriesRoute
  '/_authenticated/data/search-terms': typeof AuthenticatedDataSearchTermsRoute
  '/_authenticated/evaluation/retrieval': typeof AuthenticatedEvaluationRetrievalRoute
  '/_authenticated/golden/judge': typeof AuthenticatedGoldenJudgeRoute
  '/_authenticated/golden/review': typeof AuthenticatedGoldenReviewRoute
  '/_authenticated/ocpp/cpa-change-history': typeof AuthenticatedOcppCpaChangeHistoryRoute
  '/_authenticated/search/force-update': typeof AuthenticatedSearchForceUpdateRoute
  '/_authenticated/search/indexes': typeof AuthenticatedSearchIndexesRoute
  '/_authenticated/search/query-console': typeof AuthenticatedSearchQueryConsoleRoute
  '/_authenticated/api-explorer/': typeof AuthenticatedApiExplorerIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/login'
    | '/logout'
    | '/api-explorer'
    | '/compare'
    | '/ocpp'
    | '/search'
    | '/auth/callback'
    | '/'
    | '/api-explorer/$service'
    | '/benchmark/concepts'
    | '/benchmark/consumer-products'
    | '/benchmark/match-products'
    | '/benchmark/search360-output'
    | '/benchmark/typo-correction'
    | '/data/queries'
    | '/data/search-terms'
    | '/evaluation/retrieval'
    | '/golden/judge'
    | '/golden/review'
    | '/ocpp/cpa-change-history'
    | '/search/force-update'
    | '/search/indexes'
    | '/search/query-console'
    | '/api-explorer/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/logout'
    | '/compare'
    | '/ocpp'
    | '/search'
    | '/auth/callback'
    | '/'
    | '/api-explorer/$service'
    | '/benchmark/concepts'
    | '/benchmark/consumer-products'
    | '/benchmark/match-products'
    | '/benchmark/search360-output'
    | '/benchmark/typo-correction'
    | '/data/queries'
    | '/data/search-terms'
    | '/evaluation/retrieval'
    | '/golden/judge'
    | '/golden/review'
    | '/ocpp/cpa-change-history'
    | '/search/force-update'
    | '/search/indexes'
    | '/search/query-console'
    | '/api-explorer'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/logout'
    | '/_authenticated/api-explorer'
    | '/_authenticated/compare'
    | '/_authenticated/ocpp'
    | '/_authenticated/search'
    | '/auth/callback'
    | '/_authenticated/'
    | '/_authenticated/api-explorer/$service'
    | '/_authenticated/benchmark/concepts'
    | '/_authenticated/benchmark/consumer-products'
    | '/_authenticated/benchmark/match-products'
    | '/_authenticated/benchmark/search360-output'
    | '/_authenticated/benchmark/typo-correction'
    | '/_authenticated/data/queries'
    | '/_authenticated/data/search-terms'
    | '/_authenticated/evaluation/retrieval'
    | '/_authenticated/golden/judge'
    | '/_authenticated/golden/review'
    | '/_authenticated/ocpp/cpa-change-history'
    | '/_authenticated/search/force-update'
    | '/_authenticated/search/indexes'
    | '/_authenticated/search/query-console'
    | '/_authenticated/api-explorer/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/login",
        "/logout",
        "/auth/callback"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/api-explorer",
        "/_authenticated/compare",
        "/_authenticated/ocpp",
        "/_authenticated/search",
        "/_authenticated/",
        "/_authenticated/benchmark/concepts",
        "/_authenticated/benchmark/consumer-products",
        "/_authenticated/benchmark/match-products",
        "/_authenticated/benchmark/search360-output",
        "/_authenticated/benchmark/typo-correction",
        "/_authenticated/data/queries",
        "/_authenticated/data/search-terms",
        "/_authenticated/evaluation/retrieval",
        "/_authenticated/golden/judge",
        "/_authenticated/golden/review"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/_authenticated/api-explorer": {
      "filePath": "_authenticated.api-explorer.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/api-explorer/$service",
        "/_authenticated/api-explorer/"
      ]
    },
    "/_authenticated/compare": {
      "filePath": "_authenticated.compare.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/ocpp": {
      "filePath": "_authenticated.ocpp.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/ocpp/cpa-change-history"
      ]
    },
    "/_authenticated/search": {
      "filePath": "_authenticated.search.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/search/force-update",
        "/_authenticated/search/indexes",
        "/_authenticated/search/query-console"
      ]
    },
    "/auth/callback": {
      "filePath": "auth.callback.tsx"
    },
    "/_authenticated/": {
      "filePath": "_authenticated.index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/api-explorer/$service": {
      "filePath": "_authenticated.api-explorer.$service.tsx",
      "parent": "/_authenticated/api-explorer"
    },
    "/_authenticated/benchmark/concepts": {
      "filePath": "_authenticated.benchmark.concepts.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/benchmark/consumer-products": {
      "filePath": "_authenticated.benchmark.consumer-products.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/benchmark/match-products": {
      "filePath": "_authenticated.benchmark.match-products.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/benchmark/search360-output": {
      "filePath": "_authenticated.benchmark.search360-output.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/benchmark/typo-correction": {
      "filePath": "_authenticated.benchmark.typo-correction.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/data/queries": {
      "filePath": "_authenticated.data.queries.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/data/search-terms": {
      "filePath": "_authenticated.data.search-terms.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/evaluation/retrieval": {
      "filePath": "_authenticated.evaluation.retrieval.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/golden/judge": {
      "filePath": "_authenticated.golden.judge.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/golden/review": {
      "filePath": "_authenticated.golden.review.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/ocpp/cpa-change-history": {
      "filePath": "_authenticated.ocpp.cpa-change-history.tsx",
      "parent": "/_authenticated/ocpp"
    },
    "/_authenticated/search/force-update": {
      "filePath": "_authenticated.search.force-update.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/search/indexes": {
      "filePath": "_authenticated.search.indexes.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/search/query-console": {
      "filePath": "_authenticated.search.query-console.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/api-explorer/": {
      "filePath": "_authenticated.api-explorer.index.tsx",
      "parent": "/_authenticated/api-explorer"
    }
  }
}
ROUTE_MANIFEST_END */
